import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorIsSWInitStatusRetrieved = (state) => {
  return state[KEY_REDUCER_SW].isSWInitStatusRetrieved;
};